import React, { FC } from 'react';
import UtilFunctions from '~utils/functions';
import * as ChipStyles from './_chip.module.scss';

type ChipProps = {
    label: string,
    type?: 'success' | 'warning' | 'error' | 'inactive' | 'info',
    className?: string;
    testId?: string;
}

const Chip: FC<ChipProps> = ({
    label,
    type = 'success',
    className,
    testId,
}) => {

    const chipStyles = UtilFunctions.Styles.concatClassNames([
        ChipStyles.container,
        (type ? ChipStyles[`${type}`] : ''),
        (className ? className : ''),
    ]);

    return (
        <div data-testid={testId} className={chipStyles}>
            {label}
        </div>
    );
};

export default Chip;
